// ThreePointViewMarker.js
import { GalleryMarkerBase } from "./GalleryMarkerBase.js";

// Read-only Viewpoint mit 3 Punkten (Sichtkegel): nur der Origin-Marker. Den Kegel zeichnet die zentrale
// LocationShapeLayer (WYSIWYG = Editor-Mathe). Früher: zwei google.maps.Polygon via ProjectionHelper, die im
// overlayLayer unter den Overlays lagen (+ asynchrones 'ready'-Warten auf die Projektion — entfällt jetzt).
export class ThreePointViewMarker extends GalleryMarkerBase {
    draw(map) {
        const latLng = this.mapAdapter.createLatLng(this.points[0].lat, this.points[0].lng);
        const marker = this.createOriginMarker(latLng);
        this.drawnElements.push(marker);
    }
}
